import 'highcharts'
import 'highcharts.nodata'
import { colors } from '@PipelineDeals/shared-react-components'

const renderHighchart = (container, data) => {
  const Highcharts = window.Highcharts

  data.chart.renderTo = container
  data.chart.backgroundColor = colors.white

  if (data.customTooltip) {
    data.tooltip.formatter = function () {
      return this.point.options.tooltip
    }
  }

  if (data.thousandsFormatter) {
    data.plotOptions[data.chart.type].dataLabels.formatter = function () {
      if (this.y > 1000) {
        return Highcharts.numberFormat(this.y / 1000, 1) + 'K'
      } else {
        return Highcharts.numberFormat(this.y, 0)
      }
    }
  }

  new Highcharts.Chart(data) // eslint-disable-line no-new
  return data
}

export default renderHighchart
